import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IGetReportDocumentosUseCase } from "../../../presentation/useCases/read/get_report_documentos_use_case";
import { RangedDate } from "../../../../../common/utils/ranged_date_utils";
import { ReportData } from "../../models/report_data";
import { ReportMimeType } from "../../../../../common/utils/report_callback";

import dayjs from "dayjs";

/**
 * GetReportDocumentosUseCase
 */

export class GetReportDocumentosUseCase implements IGetReportDocumentosUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportDocumentos(
    requiredMimeType: ReportMimeType | null,
    idUsuario: number,
    centroCusto: number[] | null,
    funcionario: number[] | null,
    statusDocumento: number | null,
    situacao: number | null,
    statusFuncionario: number | null,
    dataVencimento: RangedDate,
    dataEmissao: RangedDate

  ): Promise<ReportData> {
    const response = await this.repository.getReportDocumentos(
      requiredMimeType,
      idUsuario,
      funcionario,
      statusDocumento,
      centroCusto,
      situacao,
      statusFuncionario,
      dataVencimento.dataDe,
      dataVencimento.dataAte,
      dataEmissao.dataDe,
      dataEmissao.dataAte
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `documentos_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
